// extracted by mini-css-extract-plugin
export default {"label":"CalendarTimezoneLabel_label__i08i+"};